'use client';

import { HiSparkles } from 'react-icons/hi';
import { FiEyeOff, FiEye, FiRefreshCw } from 'react-icons/fi';
import { cn } from '@/utils/uiUtils';
import { useState } from 'react';

interface ChatHeaderProps {
  className?: string;
  refreshMessages: () => Promise<void>;
}

export const ChatHeader = ({ className, refreshMessages }: ChatHeaderProps) => {
  const [showIntermediateSteps, setShowIntermediateSteps] = useState(false);
  const showIntermediateStepsToggle = false;
  return (
    <div
      className={cn(['w-full flex items-center gap-4 py-0 px-4', className])}
    >
      <div className='flex items-center justify-center gap-4 flex-1 text-yellow-400'>
        <HiSparkles className='w-4 h-4 md:w-6 md:h-6' />
        <h2 className='h2'>AI Coach</h2>
      </div>
      <div className='flex items-center justify-end gap-4'>
        <button
          onClick={refreshMessages}
          className='btn'
          title='Refresh messages'
        >
          <FiRefreshCw className='w-4 h-4 md:w-6 md:h-6' />
        </button>
        {showIntermediateStepsToggle && (
          <button
            type='button'
            className={`${showIntermediateSteps ? 'active' : ''}`}
            onClick={() => setShowIntermediateSteps(!showIntermediateSteps)}
            title='Show intermediate steps'
          >
            {showIntermediateSteps && (
              <FiEyeOff className='w-4 h-4 md:w-6 md:h-6' />
            )}
            {!showIntermediateSteps && (
              <FiEye className='w-4 h-4 md:w-6 md:h-6' />
            )}
          </button>
        )}
      </div>
    </div>
  );
};
